import styled from 'styled-components'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CardSection = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 32px 28px;
  margin-bottom: 32px;
`

// export const SectionTitle = styled.h5`
//   font-size: 1.125rem;
//   font-weight: 600;
//   color: #5e5c64;
//   margin: 0 0 20px 0;
//   border-bottom: 1px solid #ebebeb;
//   padding-bottom: 8px;
// `


export const SectionTitle = styled.div`
  color: #888;
  font-size: 15px;
  font-weight: 600;
  margin-top: 1.0rem;
  margin-bottom: 0.5rem;
  position: relative;
  padding-bottom: 12px;
`

export const LinkSection = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
`

export const LinkLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: block;
`

export const LinkInputGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 24px;

  > div:first-child {
    flex: 1;
  }
`

export const CopyButton = styled(Button)`
  && {
    background: #e6f2fa;
    border-color: #0072bc;
    color: #0072bc;
    font-weight: 600;
    padding: 6px 14px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: 6px;
    font-size: 0.875rem;
    white-space: nowrap;
    
    &:hover, &:focus, &:active {
      background: #cce5f5 !important;
      border-color: #005a96 !important;
      color: #005a96 !important;
    }
  }
`

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FormLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 4px;
  display: block;
`

export const RequiredMark = styled.span`
  color: #ff0000;
  margin-left: 2px;
`

export const DaysGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding: 8px 0;
`

export const DayCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  
  .form-check-input {
    cursor: pointer;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 1px solid #adb5bd;
    
    &:checked {
      background-color: #0072bc;
      border-color: #0072bc;
    }
    
    &:focus {
      box-shadow: 0 0 0 0.15rem rgba(0, 114, 188, 0.25);
    }
  }
  
  .form-check-label {
    cursor: pointer;
    font-weight: 500;
    font-size: 0.875rem;
    color: #495057;
    margin-left: 6px;
  }
`

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  
  .form-check {
    padding-left: 0;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .form-check-input {
    margin-left: 0;
    float: none;
    width: 40px;
    height: 20px;
    cursor: pointer;
  }

  .form-check-label {
    cursor: pointer;
    font-weight: 600;
    font-size: 0.875rem;
    color: #5c5c5c;
  }
`

export const SectionDivider = styled.div`
  height: 1px;
  background: #ebebeb;
  margin: 32px 0;
`

export const SubSectionTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 600;
  color: #6c757d;
  margin: 0 0 20px 0;
`

export const HelperText = styled.p`
  font-size: 0.75rem;
  color: #667085;
  margin: 0 0 8px;
  line-height: 1.4;
`

export const FieldsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
  max-width: 480px;
`

export const InfoBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;

  .info-icon {
    color: #0072bc;
    font-size: 1rem;
    margin-top: 2px;
    flex-shrink: 0;
  }

  p {
    font-size: 0.875rem;
    color: #495057;
    margin: 0;
    line-height: 1.4;
  }
`

export const FieldGroup = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  label,
  .form-label {
    color: #464646;
    font-weight: 600;
  }

  .required-mark,
  .text-danger,
  label .required-mark {
    color: #ff0000 !important;
  }
`

export const FieldLabel = styled.label`
  font-size: 16px;
  font-weight: 700 !important;
  line-height: 140%;
  color: #5c5c5c !important;
  margin-bottom: 6px;
  display: block;
`

export const InformationBox = styled.aside`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 1200px;
  min-height: 72px;
  padding: 0 24px;
  margin-top: 24px;
  background-color: var(--white);
  border: 1px solid var(--border);
  border-left: 5px solid #0d6efd;
  border-radius: 4px;
  opacity: 1;
  box-sizing: border-box;
  box-shadow:
    0px var(--Elevation1OffsetY1, 1px) var(--Elevation1Radius1, 2px) 0px var(--shadow-smooth),
    0px var(--Elevation1OffsetY2, 2px) var(--Elevation1Radius2, 4px) 0px var(--shadow-smooth);

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    min-height: auto;
    padding: 16px;
    gap: 12px;
  }
`

export const InformationIcon = styled(FontAwesomeIcon)`
  font-size: 25px;
  color: #0d6efd;
`

export const InformationText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #5c5c5c;
`